<template>
  <path pid="0" d="M13 2a11 11 0 1011 11A11 11 0 0013 2zm0 20a9 9 0 119-9 9 9 0 01-9 9z"/><path pid="1" d="M16.92 7.82l-6.36 2.12a1 1 0 00-.63.63l-2.12 6.36a1 1 0 001.27 1.26l6.36-2.12a1 1 0 00.63-.63l2.12-6.36a1 1 0 00-1.27-1.26zm-2.59 6.51l-4 1.33 1.33-4 4-1.33z"/>
</template>
